import { DEFAULT_LICENSE_COUNT } from 'bundles/wes-common/constants/billing';

/**
 * Default `learnerCount` when absent from the URL (e.g. `/purchase/plan` redirect).
 * Implemented as a function so allocation / A/B logic can be reintroduced later without churning call sites.
 */
export function getDefaultCheckoutLearnerCount(): number {
  return DEFAULT_LICENSE_COUNT;
}
